import { render } from "./SubscriptionFee.vue?vue&type=template&id=8ccfea18&scoped=true"
import script from "./SubscriptionFee.vue?vue&type=script&lang=js"
export * from "./SubscriptionFee.vue?vue&type=script&lang=js"

import "./SubscriptionFee.vue?vue&type=style&index=0&id=8ccfea18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccfea18"]])

export default __exports__